<script lang="ts" setup>
import type { ProductListResponseItem } from 'types';

const layout = useLayout();
defineProps<{
  productItem?: ProductListResponseItem;
}>();

const isHovering = ref<boolean>(false);
</script>

<template>
  <BaseLink
    v-if="productItem?.url"
    :to="productItem?.url"
    class="group flex min-h-[360px] flex-col gap-y-1"
    :class="[isHovering ? 'hover' : '']"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <figure
      v-if="productItem.media?.url"
      class="overflow-clip"
    >
      <BaseImage
        class="w-full object-cover transition-all duration-300 ease-out group-hover:scale-105"
        :image="productItem.media"
        :modifiers="{
          mode: 'crop',
          center: `${productItem?.media.focalPoint?.left},${productItem?.media.focalPoint?.top}`,
        }"
        :width="layout.isDesktop ? 450 : 200"
        :height="layout.isDesktop ? 300 : 135"
      />
    </figure>
    <div
      v-else
      class="mb-2 flex h-[115px] max-h-full w-full bg-primary text-white lg:h-[300px]"
    />

    <div class="flex w-full flex-col">
      <h4
        v-if="productItem?.title"
        class="md:text-2xl"
      >
        {{ productItem.title }}
      </h4>
      <span
        v-if="productItem?.longDescription"
        class="line-clamp-1 text-sm text-gray-60 lg:text-base"
      >
        <BaseRte :content="productItem?.longDescription" />
      </span>
    </div>
  </BaseLink>
</template>
